/**
 * 多语言 mixin
 * 提供方法根据当前语言获取翻译字段值
 */
import langManager from "../model/lang";

export default {
  methods: {
    /**
     * 获取翻译后的字段值
     * @param {Object} i18nMap - 后端返回的 i18n 数据，如 { en_us: { title: '...', desc: '...' } }
     * @param {string} field - 字段名，如 'title', 'desc', 'personName'
     * @param {string} fallback - 原始值（中文），翻译不存在时回退
     * @returns {string}
     */
    $i18nField(i18nMap, field, fallback) {
      if (!i18nMap || langManager.current === "zh_CN") {
        return fallback;
      }
      var suffix = langManager.getFieldSuffix(); // en_us
      var langData = i18nMap[suffix];
      if (langData && langData[field]) {
        return langData[field];
      }
      return fallback;
    },

    /**
     * 获取扁平结构翻译值
     * @param {Object} i18nMap - 扁平结构，如 { name_en_us: "...", address_en_us: "..." }
     * @param {string} fieldBase - 字段基名，如 "name"（会拼成 name_en_us）
     * @param {string} fallback - 原始值（中文），翻译不存在时回退
     * @returns {string}
     */
    $i18nFlat(i18nMap, fieldBase, fallback) {
      if (!i18nMap || langManager.current === "zh_CN") {
        return fallback;
      }
      var suffix = langManager.getFieldSuffix(); // en_us
      var key = fieldBase + "_" + suffix; // name_en_us
      if (i18nMap[key]) {
        return i18nMap[key];
      }
      return fallback;
    },

    /**
     * 获取当前语言状态
     */
    $currentLang() {
      return langManager.current;
    },

    /**
     * 是否非简体中文
     */
    $isNonCn() {
      return langManager.isNonCn();
    },
  },
};
